module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "i85"
    }
  }), _c('a', {
    attrs: {
      "id": "i443"
    }
  }), _c('a', {
    attrs: {
      "id": "i515"
    }
  }), _c('a', {
    attrs: {
      "id": "i630"
    }
  }), _c('a', {
    attrs: {
      "id": "i1221"
    }
  }), _c('a', {
    attrs: {
      "id": "i1647"
    }
  }), _c('a', {
    attrs: {
      "id": "i1733"
    }
  }), _c('a', {
    attrs: {
      "id": "i1923"
    }
  }), _c('a', {
    attrs: {
      "id": "i2242"
    }
  }), _c('a', {
    attrs: {
      "id": "i2301"
    }
  }), _c('a', {
    attrs: {
      "id": "i2433"
    }
  }), _c('a', {
    attrs: {
      "id": "i2488"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap2"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('h4', {
    staticClass: "sect1"
  }, [_vm._v("May—June 1984")]), _vm._v(" "), _c('p', {
    staticClass: "noindentk"
  }, [_vm._v("It had been raining steadily in the Valley for two days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of May had been wet, and by now it was getting hard to remember a day when it hadn’t rained. Total rainfall for the month was approaching record levels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even in ordinary times it was impossible to go anywhere in the Valley without being aware of the presence of running water, friendly, cheerful, comforting. It flowed under a bridge beneath the road, it splashed and gurgled near a familiar path through the woods, it trickled across a meadow to fill a cow pond, it moved with slow majesty in the Connecticut River, which both separated and connected New Hampshire and Vermont. The big river formed the spine of the Valley, flowing always just below the consciousness of everyone who lived within a dozen miles of its banks on either side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But now the water was out of control. All up and down the Valley roads were closed and students were sent home early. Town and village schools stayed closed on Tuesday in Cavendish and Chester and Londonderry on the Vermont side of the river, and roads were washed out in Weathersfield and Ludlow. In the little city of Springfield, twenty feet of sidewalk collapsed at the corner of Mount Vernon Street and Gulf Road.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the New Hampshire side, the "), _c('a', {
    attrs: {
      "id": "i2342"
    }
  }), _vm._v("Sugar River, a favored trout stream that fed the Connecticut, was overflowing its banks throughout Newport. Downstream from Newport, the business district of Claremont was safe up on its hill, but on the flats below, where the Sugar River flowed through the "), _c('a', {
    attrs: {
      "id": "i172"
    }
  }), _vm._v("Beauregard Village section just before joining the Connecticut, the fire department was keeping watch. Volunteers were helping to scoop out debris and clear culverts, to keep the water from backing up and washing over the roads."), _c('a', {
    attrs: {
      "id": "i444"
    }
  }), _c('a', {
    attrs: {
      "id": "i591"
    }
  }), _c('a', {
    attrs: {
      "id": "i621"
    }
  }), _c('a', {
    attrs: {
      "id": "i651"
    }
  }), _c('a', {
    attrs: {
      "id": "i694"
    }
  }), _c('a', {
    attrs: {
      "id": "i890"
    }
  }), _c('a', {
    attrs: {
      "id": "i942"
    }
  }), _c('a', {
    attrs: {
      "id": "i1193"
    }
  }), _c('a', {
    attrs: {
      "id": "i1211"
    }
  }), _c('a', {
    attrs: {
      "id": "i1453"
    }
  }), _c('a', {
    attrs: {
      "id": "i1720"
    }
  }), _c('a', {
    attrs: {
      "id": "i1946"
    }
  }), _c('a', {
    attrs: {
      "id": "i2043"
    }
  }), _c('a', {
    attrs: {
      "id": "i2103"
    }
  }), _c('a', {
    attrs: {
      "id": "i2275"
    }
  }), _c('a', {
    attrs: {
      "id": "i2352"
    }
  }), _c('a', {
    attrs: {
      "id": "i2401"
    }
  }), _c('a', {
    attrs: {
      "id": "i2413"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-8"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beauregard Village was the last place anybody saw Bernice Courtemanche.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bernice’s boyfriend, Teddy "), _c('a', {
    attrs: {
      "id": "i193"
    }
  }), _c('a', {
    attrs: {
      "id": "i196"
    }
  }), _c('a', {
    attrs: {
      "id": "i201"
    }
  }), _vm._v("Berry, called her at work at the Sullivan County Nursing Home on Wednesday. They arranged that Bernice would come to meet him at his sister’s place in Newport after she got off work at three o’clock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bernice decided to go home to get some things before heading over to Newport, so she asked Bonnie "), _c('a', {
    attrs: {
      "id": "i2300"
    }
  }), _vm._v("Spicer, who was getting off work at the same time, for a ride into Claremont. From the nursing home, in the little town of Unity, it was less than ten minutes’ drive north to the house in Beauregard Village, where they had been living with Teddy’s parents. She’d get a snack and change, then hitchhike the ten miles east to Newport. She hitched rides a lot these days and it was a good way to get around, but she was due to get her driver’s license soon and she was looking forward to it. She wouldn’t have to depend on strangers so much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bonnie dropped her off at the corner of Main Street, where it came down the hill from the center "), _c('a', {
    attrs: {
      "id": "i174"
    }
  }), _vm._v("of Claremont, and Citizen Street, which led off to the left across the "), _c('a', {
    attrs: {
      "id": "i2343"
    }
  }), _vm._v("Sugar River into Beauregard Village. It was still overcast, but the rain had let up, at least for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teddy’s parents, Janet and Arthur Berry, lived in a small yellow house a few blocks into the village. They arrived home around three-thirty. Janet stayed outside in the truck with the motor running while Arthur ran inside to get something. Bernice was sitting at the kitchen table eating a peanut butter sandwich. She told Arthur she was planning to go to Newport to meet Teddy at his sister’s. He offered her a ride. She said, no, she’d get a ride easily enough.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentk"
  }, [_vm._v("Teddy wasn’t worried at first. They hadn’t been definite about what time she’d get to Newport, and he knew Bernice might have had trouble getting a ride. It wasn’t until darkness fell that he started wondering what was holding her up. He called home first but she wasn’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe she had gone to her parents’ house. When he phoned he learned that her parents had rushed off to Boston with Bernice’s younger brother. He had gotten a fish hook caught near his eye and they wanted him to get specialized attention at the Boston Eye and Ear Infirmary. That was close to two hours’ drive, so they would be late getting back. Could Bernice have gone with them? No, she hadn’t been around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Around six-thirty Teddy and his sister’s husband, Robert, went out to see if they could find her. They drove the ten miles from Newport to"), _c('a', {
    attrs: {
      "id": "i424"
    }
  }), _c('a', {
    attrs: {
      "id": "i652"
    }
  }), _c('a', {
    attrs: {
      "id": "i676"
    }
  }), _c('a', {
    attrs: {
      "id": "i1977"
    }
  }), _c('a', {
    attrs: {
      "id": "i1996"
    }
  }), _c('a', {
    attrs: {
      "id": "i2000"
    }
  }), _c('a', {
    attrs: {
      "id": "i2033"
    }
  }), _c('a', {
    attrs: {
      "id": "i2149"
    }
  }), _c('a', {
    attrs: {
      "id": "i2180"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _vm._v(" Claremont, searching the roadside and anywhere she might have gotten sidetracked. In Claremont they checked all the likely places. No luck. Finally they decided to sleep on it. Bernice was an independent type. They told themselves it was just possible to imagine her staying away overnight, and maybe something had kept her from calling so far. It wasn’t like Bernice to just take off and not come back the next day; she’d turn up, they said to each other. But their hopeful imaginings didn’t carry much conviction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the morning there was still no sign of her, and no word. At twelve-fifteen "), _c('a', {
    attrs: {
      "id": "i210"
    }
  }), _vm._v("Teddy called the Claremont police. Bernice Courtemanche went into the official records as a missing person.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentk"
  }, [_vm._v("The rain and cloudy skies had intruded on the activities of the long Memorial Day weekend, but it wasn’t as if Mike Prozzo ever got very far away from his work, no matter what he was doing. He hadn’t expected it to turn out that way. He had hated the idea of being transferred to the detective division when the chief first told him about it. It had felt like a punishment. That had been two and half years ago, and at the time he couldn’t imagine anything that suited him more than being a uniformed cop, walking the streets, keeping an eye on things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prozzo had grown up in Claremont and it felt as if he knew everybody in town. As a child he had just assumed he would go into the family business. His father had come back from World War II and started a dry-cleaning store, naming it Veterans Cleaners in honor of his recent experience and his fellow soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a real family business. Michael’s grandfather, uncle, and mother had all worked there with his father at one time or another, and his older brother and sister had helped out while they were in school. But by the time Michael was finishing high school at St. Mary’s Catholic in Claremont, it was clear that his older sister and brother had other career plans; she was on her way to becoming a hairdresser, he was going to business college, majoring in accounting. Michael, who was helping out in the store himself now, was his father’s last hope to take over the business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The problem was, they couldn’t work together. The old man knew how he wanted things to be done, and that was that. And as Michael got older, he started to feel he knew how things ought to be done, too, and it wasn’t always the same way his father wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re both thick-headed Guineas,” Prozzo said years later, his smile taking the sting out of the coarse ethnic slur he had heard more"), _c('a', {
    attrs: {
      "id": "i108"
    }
  }), _c('a', {
    attrs: {
      "id": "i632"
    }
  }), _c('a', {
    attrs: {
      "id": "i1122"
    }
  }), _c('a', {
    attrs: {
      "id": "i1398"
    }
  }), _c('a', {
    attrs: {
      "id": "i1885"
    }
  }), _c('a', {
    attrs: {
      "id": "i1936"
    }
  }), _c('a', {
    attrs: {
      "id": "i2018"
    }
  }), _c('a', {
    attrs: {
      "id": "i2034"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-10"
    }
  }), _vm._v(" than once as a young man. Being Italian really had nothing to do with it; the story of a father and son clashing at close quarters was as old as time, and there was no room for compromise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time, Prozzo had harbored good feelings about cops and their work ever since he was a child. There were always beat cops around his father’s store, and when he was eight years old a veteran Claremont officer named Arnie "), _c('a', {
    attrs: {
      "id": "i873"
    }
  }), _vm._v("Foosse had given him a police whistle. Michael and a friend sat on a stoop on Washington Street and blew the whistle at cars that looked like they were going too fast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In high school he discovered that other people accepted him as a leader. He was chosen cocaptain of the soccer team and elected an officer of the student council. And when he went into the National Guard soon after graduating from high school, he was singled out for promotion to PFC, then to corporal, and later to sergeant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prozzo wasn’t given to self-analysis, but in later years it occurred to him that these experiences contributed to his feeling that he could never get along in the dry-cleaning business. When he finished Guard training in South Carolina he went back to the store, but it didn’t feel right any longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At that point,” he recalled, “in my father’s business he was the leader and I was the follower, and I would rather have been the leader. I always liked leading people, and I don’t like following.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was easier to make the decision than it was to tell his father about it. For all the conflict, they were still close, and Michael didn’t want to disappoint his father. He was still living at home, and he eased into the police department at first, with part-time work as a “special.” He helped out on traffic duty or worked special events when he wasn’t needed in the dry-cleaning store. Then a full-time position opened up in the department. Prozzo applied and was accepted. The critical moment had arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can remember like it was yesterday,” Prozzo said, “going home and telling my father that I wasn’t going to work for him any longer.” His laugh betrayed the tension of the moment even when it was close to two decades in the past. The elder Prozzo had been taking his midday break from the store, sitting in his armchair in the corner of the living room at home. The television was on but it was hard to tell if he was watching or dozing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to talk with you for a minute,” Michael said to his father, and then he told him he was going to work full-time in the police department and wouldn’t be helping out in the store anymore. The"), _c('a', {
    attrs: {
      "id": "i110"
    }
  }), _c('a', {
    attrs: {
      "id": "i1362"
    }
  }), _c('a', {
    attrs: {
      "id": "i1367"
    }
  }), _c('a', {
    attrs: {
      "id": "i1978"
    }
  }), _c('a', {
    attrs: {
      "id": "i1997"
    }
  }), _c('a', {
    attrs: {
      "id": "i2001"
    }
  }), _c('a', {
    attrs: {
      "id": "i2035"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-11"
    }
  }), _vm._v(" reaction was curiously muted, and Michael was relieved, but he could tell from his father’s manner how disappointed he was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it was more than two decades later, the elder Prozzos had just sold the dry-cleaning store and moved to Florida, and their son had risen steadily in the Claremont "), _c('a', {
    attrs: {
      "id": "i463"
    }
  }), _vm._v("Police Department. In 1981, when he was a lieutenant in charge of the uniformed division, he had applied to become chief, but the job went to someone else. When the new chief transferred him to head the detectives a few months later, Prozzo was convinced that insecurity was responsible for the move, that his visibility in the community as head of the uniformed officers on the street posed a threat to his boss, a newcomer to Claremont.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That wasn’t the only reason for his disappointment with the shift. Prozzo had no interest whatever in being a detective. The duties of an officer on patrol fit him like his sharply tailored uniform shirt. Ducking in and out of stores and restaurants and bars, anywhere people gathered, stopping to chat on the street, keeping up with what was going on in town, anticipating problems and preventing them from developing, resolving disputes, collaring troublemakers, none of that seemed like work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prozzo "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knew")]), _vm._v(" these people. He was a glutton for professional self-improvement—he had once figured out that in less than eighteen years on the force he had spent a total of almost two years in courses of various kinds—and he was especially proud of having been selected in 1978 to go to the "), _c('a', {
    attrs: {
      "id": "i801"
    }
  }), _vm._v("FBI Academy, where cops from all over the country learn about the latest law-enforcement issues and techniques. But he also knew that police work in a small place like Claremont depended on knowing the community and its people much more than on technology and methods. That was the part of the job that he loved. For a gregarious person like Prozzo, a man who moved among the people of Claremont like a fish in a pond, being a street cop was as easy and natural as breathing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even so, within a year or so after he had been taken away from the uniformed division Prozzo could hardly remember why he had objected to the idea so strenuously, and his disappointment had turned into gratitude to the chief who had made the move. Perhaps the chief had understood something that wasn’t visible to Prozzo himself. Prozzo loved the work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the two and a half years since the transfer he had instituted a series of changes to make the detective division function more efficiently, but the part Prozzo enjoyed most was the change he felt in himself. He had"), _c('a', {
    attrs: {
      "id": "i131"
    }
  }), _c('a', {
    attrs: {
      "id": "i150"
    }
  }), _c('a', {
    attrs: {
      "id": "i526"
    }
  }), _c('a', {
    attrs: {
      "id": "i677"
    }
  }), _c('a', {
    attrs: {
      "id": "i1181"
    }
  }), _c('a', {
    attrs: {
      "id": "i1195"
    }
  }), _c('a', {
    attrs: {
      "id": "i1378"
    }
  }), _c('a', {
    attrs: {
      "id": "i1629"
    }
  }), _c('a', {
    attrs: {
      "id": "i1985"
    }
  }), _c('a', {
    attrs: {
      "id": "i1998"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }), _vm._v(" learned how to see the broad picture, how to manage a case, how to talk with suspects, how to work within the legal restrictions to gather evidence for a prosecution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of all, it was the interview, the confrontation with the suspect, that he loved. It was a psychological game, and it required a feel for people, a gut-level understanding of character and personality. The transfer to detective work offered a whole new set of challenges, and Mike Prozzo found that his ability to meet them was a rich new source of professional achievement and satisfaction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But now, as Prozzo returned to work after a long Memorial Day weekend, his enthusiasm was about to run head-on into a case that would gradually expand to touch every corner of the community in which he was so deeply immersed, and his professional confidence was soon to be tested in a way that went far beyond anything he had ever experienced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leafing through the preliminary reports turned in by detectives and officers in his absence, Prozzo saw little at first in the case of Bernice Courtemanche to produce the chill of concern that usually signalled something special. A seventeen-year-old girl with no apparent reason to take off was missing. Officers had checked with her boyfriend, Teddy "), _c('a', {
    attrs: {
      "id": "i202"
    }
  }), _vm._v("Berry, his parents and sister, Bernice’s parents, a couple of her teachers, a supervisor at the nursing home. There wasn’t anything in these preliminary interviews to distinguish Bernice Courtemanche from a lot of other runaways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s not the first juvenile that we’ve had missing,” Prozzo thought to himself. Even in a quiet place like Claremont, that happened all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truth was, it had been happening more and more in the last few years. In the previous twelve months, 237 adults and 95 children had been reported missing in Claremont. In a single year, the number of people who disappeared for long enough to provoke a report to the police department equalled one of every forty-four people in Claremont.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among almost a hundred children reported missing in the twelve months before Bernice Courtemanche disappeared, a three-year-old had wandered less than a block to her grandmother’s house, then found her way home twenty minutes later. A sixteen-year-old girl turned up at the home of friends after a day and a half; it was the fourth time she had run away. A retarded eight-year-old wandered away when his brother, who was assigned to watch him, got distracted; he was found after ten minutes in the bushes near his house. A two-year-old was snatched by his mother from a department store; the parents were fighting for custody of the child. And little clusters of youngsters, ten to fifteen years old,"), _c('a', {
    attrs: {
      "id": "i157"
    }
  }), _c('a', {
    attrs: {
      "id": "i211"
    }
  }), _c('a', {
    attrs: {
      "id": "i425"
    }
  }), _c('a', {
    attrs: {
      "id": "i653"
    }
  }), _c('a', {
    attrs: {
      "id": "i678"
    }
  }), _c('a', {
    attrs: {
      "id": "i1373"
    }
  }), _c('a', {
    attrs: {
      "id": "i1986"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }), _vm._v(" were constantly disappearing for a few hours from "), _c('a', {
    attrs: {
      "id": "i1788"
    }
  }), _vm._v("Orion House, a local home for troubled children. These cases, where the children were located within a short time, usually hours, at most a couple of days, were typical.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But there were exceptions, tragic exceptions. The year before, just a dozen miles away, across the river in Vermont, an eleven-year-old girl had been kidnapped on an April Saturday. Her body was found the following day; she had been murdered. Long after the case had been solved her parents were left with the thought that somehow the horror might have been prevented. They initiated a lawsuit against the local police department, claiming it had not reacted quickly or comprehensively enough to the report of the kidnapping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And it was the possibility of this kind of exception, the thought that a child might have come to harm, that sharpened the attention of anyone who heard a report that a young person was missing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In March of 1984 the mayor of Claremont, partly in response to the Vermont case, had appointed a committee to upgrade the city’s procedures for handling missing-persons cases. The committee was to focus especially on cases involving children. One member was the chief of police, Adam "), _c('a', {
    attrs: {
      "id": "i167"
    }
  }), _vm._v("Bauer. Chief Bauer named a young detective, Bill "), _c('a', {
    attrs: {
      "id": "i2531"
    }
  }), _vm._v("Wilmot, to serve with him on the committee. Two months after that, Wilmot was working with Mike Prozzo on the disappearance of Bernice Courtemanche.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At first look it wasn’t clear to Prozzo how the case should be treated. At seventeen, Bernice Courtemanche seemed to be on the borderline between adult and child. She was working at the nursing home, no longer dependent on her parents, living with a boyfriend away from home; but she was still living as a dependent with adults, Teddy’s parents, she was still going to school, and she still had a few months left as a minor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The information alone was equivocal: was Bernice Courtemanche an adult who could be expected to come and go on her own, or a child whose disappearance should be treated as an emergency from the first minute? It was time that provided the answer. The passage of a few days after Bernice Courtemanche’s disappearance combined with what was known about her so far to work a subtle change in Prozzo’s thinking: the business before him was shading from a missing-person case into a potential criminal matter. Bernice Courtemanche was looking more and more like a victim.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That afternoon, Prozzo went to see Teddy’s parents. Mrs. "), _c('a', {
    attrs: {
      "id": "i194"
    }
  }), _c('a', {
    attrs: {
      "id": "i197"
    }
  }), _vm._v("Berry did most of the talking, while her husband sat quietly, satisfied with being"), _c('a', {
    attrs: {
      "id": "i137"
    }
  }), _c('a', {
    attrs: {
      "id": "i175"
    }
  }), _c('a', {
    attrs: {
      "id": "i445"
    }
  }), _c('a', {
    attrs: {
      "id": "i654"
    }
  }), _c('a', {
    attrs: {
      "id": "i695"
    }
  }), _c('a', {
    attrs: {
      "id": "i1721"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-14"
    }
  }), _vm._v(" in the background. She said that Bernice and Teddy seemed very much in love. They had been talking about getting married. Mrs. "), _c('a', {
    attrs: {
      "id": "i198"
    }
  }), _c('a', {
    attrs: {
      "id": "i203"
    }
  }), _vm._v("Berry had enjoyed having Bernice living there, had come to think of her as being like a daughter. She thought Bernice liked it, too, appreciated the freedom from the tension in her parents’ home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It soon emerged that Mrs. Berry was unhappy with the effort the police were making to find Bernice. It didn’t seem like they were doing anything. Why weren’t they out looking for Bernice?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This kind of criticism wasn’t anything new for Prozzo and he tried not to take it too personally. The family of a victim always focused on their own fears and found it hard to imagine that there was other business the police had to handle at the same time. And so much of what the police were doing was invisible to anyone outside the department.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prozzo considered it part of a commander’s job to deal with this kind of impatience. In a small place like Claremont that meant offering himself in person as a whipping boy and trying to make the people feel better. He waited patiently while Mrs. Berry vented her frustration. Then he outlined for the Berrys what the department had done already and what they were planning to do in the next several days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want you to know we’re concerned about Bernice and we’re doing everything we can to find her,” he said. “We do care.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Berry seemed to accept Prozzo’s explanation, but his wife still wasn’t satisfied. Prozzo resolved to stay in touch with her, keeping them informed about all the activity aimed at finding Bernice that the public wouldn’t be able to see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among the early reports, Prozzo had found one from somebody who worked in a sheet-metal shop on North Street, a mile or so from Beauregard Village, where Bernice had last been seen. The caller had seen her get into a white pickup in front of Frank’s Neighborhood Store, across the street from the sheet-metal shop. There were two or three guys in the truck, he said. North Street would have been a natural route to take toward Newport.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one had found any further trace of her on North Street, though, and a few days later "), _c('a', {
    attrs: {
      "id": "i115"
    }
  }), _vm._v("Arthur Berry, Teddy’s father, appeared at the front window of the police station. He wanted to talk to somebody. He had heard a rumor that Bernice had been seen getting into a white pickup. He owned a white pickup, he told the officer, and he was concerned that the police might think he had something to do with Bernice’s disappearance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though Arthur Berry’s worry was a tribute to the speed and scope of the gossip network in Claremont, Prozzo wasn’t taking him seriously as"), _c('a', {
    attrs: {
      "id": "i649"
    }
  }), _c('a', {
    attrs: {
      "id": "i655"
    }
  }), _c('a', {
    attrs: {
      "id": "i696"
    }
  }), _c('a', {
    attrs: {
      "id": "i1364"
    }
  }), _c('a', {
    attrs: {
      "id": "i1635"
    }
  }), _c('a', {
    attrs: {
      "id": "i1722"
    }
  }), _c('a', {
    attrs: {
      "id": "i1987"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }), _vm._v(" a suspect in the disappearance of his son’s girlfriend. "), _c('a', {
    attrs: {
      "id": "i195"
    }
  }), _c('a', {
    attrs: {
      "id": "i199"
    }
  }), _c('a', {
    attrs: {
      "id": "i204"
    }
  }), _vm._v("Berry had been the last person to see her, he was with his wife at the time, and they were together afterward, during the time that Bernice would have been leaving for Newport.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teddy Berry was another matter. A boyfriend, lover, husband was always an obvious prospect when you were looking for someone who might harm a woman. Prozzo spent most of Tuesday tracking reports about Bernice and working on other cases. He was on the day shift, supposed to finish at five o’clock, but the case of the missing girl was taking on a feeling of urgency. Workdays were going to be longer for a while. It was almost eight o’clock before he could catch up with Teddy Berry for an interview.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teddy was barely older than Bernice and seemed very young to Prozzo. Things were going great between them, he said. They were planning to get married and get an apartment of their own. They had talked about buying a car together and driving to Florida for a vacation later in the summer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He admitted that they had argued a couple of weeks before, but it was about something minor. “I wouldn’t do anything to hurt her,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He confirmed that Bernice did hitchhike at times, but she was careful. If the driver were a woman, she wouldn’t hesitate, but if it were a man she’d check him out before taking a ride, and Teddy was sure she wouldn’t get in if there were more than one man in the car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wouldn’t go this long without contacting me,” Teddy said. “I think something bad has happened.” He couldn’t picture what it was, but she wouldn’t just disappear unless she was dead or kidnapped, or. … The thought trailed off into realms of vague but shocking speculation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The detective now felt comfortable in dropping Bernice’s boyfriend as a suspect in her disappearance. He had a good alibi, and beyond that, the boy’s concern was too genuine, and his actions had been consistent with the role of a young man shocked and upset at the disappearance of someone he cared for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bernice Courtemanche was the descendant of a historic migration. Thousands of French-speaking Canadians had come down from rural Canada in the decades on both sides of the turn of the century to take jobs in the textile mills and "), _c('a', {
    attrs: {
      "id": "i1632"
    }
  }), _vm._v("shoe factories of New England. Like Beaulieu and Therriault and a thousand others, Bernice’s family name had lost its rounded French dignity to the stiff Yankee tongue of New England. In Bernice’s generation everybody, even people of French descent, pronounced it “Cootermarsh.”"), _c('a', {
    attrs: {
      "id": "i161"
    }
  }), _c('a', {
    attrs: {
      "id": "i212"
    }
  }), _c('a', {
    attrs: {
      "id": "i470"
    }
  }), _c('a', {
    attrs: {
      "id": "i650"
    }
  }), _c('a', {
    attrs: {
      "id": "i661"
    }
  }), _c('a', {
    attrs: {
      "id": "i680"
    }
  }), _c('a', {
    attrs: {
      "id": "i964"
    }
  }), _c('a', {
    attrs: {
      "id": "i971"
    }
  }), _c('a', {
    attrs: {
      "id": "i1272"
    }
  }), _c('a', {
    attrs: {
      "id": "i1384"
    }
  }), _c('a', {
    attrs: {
      "id": "i1470"
    }
  }), _c('a', {
    attrs: {
      "id": "i1652"
    }
  }), _c('a', {
    attrs: {
      "id": "i1988"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Stephens High they said Bernice missed class more often than her teachers would have liked, but she did all right. At seventeen she was getting ready to move on, and most of her attention was clearly elsewhere, with her boyfriend, her work, her future. A teacher who saw her almost every day said there hadn’t been any obvious change in her mood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wasn’t part of the ‘In crowd,’” one teacher said, “but she was no loner. And she certainly didn’t seem as if she’d want to do any harm to herself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bernice had enjoyed her work as an aide at the nursing home. She had gone out there because her mother worked there, and she did willingly whatever needed to be done, helping to care for the patients and clean up. She got along fine with the other staff people and the patients.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Courtemanches lived in a trailer in Unity, not far from the nursing home. Bernice’s father worked at the Dartmouth Woolen Mill, one of the few working remnants of the days when the mills had dominated the economy of the Valley. Life had been tense for Bernice at home with her own family, but now that she was living with Teddy at his parents’ house, things were a lot better. Though the move was a short one in distance—there were only about fifteen thousand people in Claremont, New Hampshire’s ninth-largest city, and everything seemed close together—it brought a big improvement in her life. The "), _c('a', {
    attrs: {
      "id": "i205"
    }
  }), _vm._v("Berrys seemed to like her and enjoy having her around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prozzo found two telling details in the reports that made it look as if Bernice Courtemanche had more than routine reasons to stay around, at least in the short run: Two days after Teddy reported her missing, she was due to receive a paycheck for $113 at the nursing home. And the same day, she had an appointment to take the test for her driver’s license; she had been talking about getting her license for weeks, looking forward to it eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Prozzo’s portrait of the missing girl continued to grow more detailed, the case took on an ever more ominous look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even in the week of Bernice Courtemanche’s disappearance, the biggest crime stories in the Claremont area were about a barn fire that was the latest in a series of suspicious early-morning fires over the last six months—there was little damage because the barn was so saturated by the rain—and a Plainfield woman who was angry because roving dogs that had been killing her laying hens for months had finally gotten the last three of a flock that had once numbered twenty-five.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not so long ago in Claremont, even the worst crimes had a kind of domestic feel to them, seemed to grow out of everyday affairs. Once"), _c('a', {
    attrs: {
      "id": "i143"
    }
  }), _c('a', {
    attrs: {
      "id": "i213"
    }
  }), _c('a', {
    attrs: {
      "id": "i453"
    }
  }), _c('a', {
    attrs: {
      "id": "i1546"
    }
  }), _c('a', {
    attrs: {
      "id": "i1561"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-17"
    }
  }), _vm._v(" they had been ground up fine by local coffee-shop discussion and street-corner theorizing, such happenings seemed understandable, manageable. Someone knew, and soon everyone knew, that two men who got into a fatal argument had hated each other since they fought over a girl in high school, or that the boy who killed his father had been taking revenge for years of abuse. There was a history, a reason for what happened. Things could be explained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But somewhere along the line, everything had changed. Families flew apart and nobody seemed to know why, except to say, “It happens all the time.” The more serious forms of violence, even killings, seemed to come more frequently, and often someone died and nobody knew who they were, or where they had come from, much less who might have wanted to kill them. Claremont was changing, and with it the business of the police was changing, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Friday uniformed officers under Captain Pete "), _c('a', {
    attrs: {
      "id": "i1075"
    }
  }), _vm._v("Hickey fanned out along the banks of the "), _c('a', {
    attrs: {
      "id": "i2344"
    }
  }), _vm._v("Sugar River, searching for any sign that Bernice had somehow gotten sidetracked and passed that way. Other officers retraced the route along the roads between the bridge near the "), _c('a', {
    attrs: {
      "id": "i206"
    }
  }), _vm._v("Berrys’ house and Newport, ten miles away, where she was supposed to have met Teddy. Detectives from the Newport "), _c('a', {
    attrs: {
      "id": "i464"
    }
  }), _c('a', {
    attrs: {
      "id": "i1744"
    }
  }), _vm._v("Police Department drove all the possible routes on their side of the town line. There was no trace anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Late Saturday afternoon, a man who worked at the small airport in Lebanon, New Hampshire, eighteen miles north of Claremont, reported having seen Bernice Courtemanche the day before. She was getting out of a white Ford Falcon at the first exit from the interstate, just across the river in Vermont. He recognized her from the picture in the paper earlier in the week. Claremont asked the Vermont "), _c('a', {
    attrs: {
      "id": "i2467"
    }
  }), _vm._v("State Police to check the story out, but they were unable to learn anything more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By now, all the happier outcomes were starting to seem unlikely. The department released information about the missing girl to the "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i495"
    }
  }), _vm._v("Claremont Eagle-Times.")]), _vm._v(" A small story appeared on the front page of the Sunday paper. Under a picture of Bernice smiling broadly, the story announced that the Claremont police were “seeking information as to the whereabouts of Bernice L. Coutermanche.” The misspelling looked like something inspired by a phonetic reading of her name. The story described her as having hazel eyes and long dark brown hair, and said she was five feet ten inches tall and weighed 140 pounds. Some people who knew her were a little surprised to see how tall she was. Somehow she hadn’t seemed that big. Maybe it was because she was still so girlish. Perhaps it was her diffident manner."), _c('a', {
    attrs: {
      "id": "i68"
    }
  }), _c('a', {
    attrs: {
      "id": "i139"
    }
  }), _c('a', {
    attrs: {
      "id": "i256"
    }
  }), _c('a', {
    attrs: {
      "id": "i271"
    }
  }), _c('a', {
    attrs: {
      "id": "i380"
    }
  }), _c('a', {
    attrs: {
      "id": "i454"
    }
  }), _c('a', {
    attrs: {
      "id": "i496"
    }
  }), _c('a', {
    attrs: {
      "id": "i2353"
    }
  }), _c('a', {
    attrs: {
      "id": "i2410"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-18"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same day the story appeared, Teddy "), _c('a', {
    attrs: {
      "id": "i207"
    }
  }), _vm._v("Berry brought Bernice’s purse to the "), _c('a', {
    attrs: {
      "id": "i465"
    }
  }), _vm._v("police department. She had left it at his parents’ house. There were medications, some earrings, a datebook, the usual essential clutter of daily life’s small baggage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wouldn’t have left without taking this stuff along,” Bill "), _c('a', {
    attrs: {
      "id": "i2532"
    }
  }), _vm._v("Wilmot thought. The purse just reinforced the growing pessimism about what had happened to Bernice Courtemanche.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later that day Officer Angela "), _c('a', {
    attrs: {
      "id": "i1321"
    }
  }), _vm._v("Mains phoned the Sullivan County Nursing Home to find out what had happened with Bernice’s paycheck. She was told that Teddy Berry had picked it up on Friday, using an authorization slip signed by Bernice. Officer Mains checked with Teddy, who said Bernice had authorized him to pick up the check because she was planning to take the test for her driver’s license on Friday and wouldn’t be going in to work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The idea with a missing-person case was to jump on it hard from the start. Usually the investigation was interrupted by the person’s return, if not within hours, at least within a day or two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if the person didn’t turn up voluntarily, the best chance the police had of finding them came in the first two or three days, no more than a week, when the trail was still warm. The background check, the interviews, the search of the most likely places, all the routine of police, family, and friends, normally turned up the missing person or persuaded everybody that the person had taken off voluntarily. Either way, that put an end to the police role. There was no law against running away from home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even so, if the person didn’t return, there were still a few things left for the police to do. In the next week, the Claremont police sent a flier describing Bernice Courtemanche to other local departments in New Hampshire and Vermont, state police throughout New England, and a national search service for missing children. Beyond following up leads as they came in, there wasn’t much more they could do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Monday the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eagle-Times")]), _vm._v(" ran a tiny story on an inside page reporting that Bernice was still missing, inviting anyone with information to phone the Claremont Police Department. It added the information that she had been wearing a blue denim jacket, denim pants, and brown suede shoes when she was last seen. She had been missing for six days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the last mention of the missing girl in the newspaper. Over the next few weeks there were occasional reports from people claiming they had seen Bernice Courtemanche after she was reported missing; in time they all proved to be mistaken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the offices and stores of Claremont, over coffee in the diner on the"), _c('a', {
    attrs: {
      "id": "i118"
    }
  }), _c('a', {
    attrs: {
      "id": "i223"
    }
  }), _c('a', {
    attrs: {
      "id": "i679"
    }
  }), _c('a', {
    attrs: {
      "id": "i1263"
    }
  }), _c('a', {
    attrs: {
      "id": "i1837"
    }
  }), _c('a', {
    attrs: {
      "id": "i1989"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }), _vm._v(" square, in the bars, when people talked of Bernice Courtemanche, there was usually someone present with a relative or friend who knew the missing girl or her family. After all, they were saying, she wasn’t the most faithful person about going to school, and everyone knew that kids around her age were taking off all the time. Maybe it was wishful thinking rather than conviction, a defense against the anticipation of tragedy, but the consensus was that Bernice had taken off on her own. She’d show up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among those who knew her better, by now the early optimism had subsided along with the flood waters. Teddy "), _c('a', {
    attrs: {
      "id": "i200"
    }
  }), _c('a', {
    attrs: {
      "id": "i208"
    }
  }), _vm._v("Berry’s mother was having vivid nightmares in which she saw Bernice tied to a tree. “Please, help me,” Bernice pleaded in the dream, “somebody come and help me.” For weeks Janet Berry had searched the woods, hoping that the nightmare was somehow offering a sign, a lead to what had happened to her son’s girlfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the family of the missing girl, for Teddy and his parents and Bernice’s friends and the people who worked with her, now there was only uncertainty, but it was an ambiguous, double-edged uncertainty. There was the desperate need for some resolution, the urgent wish to know what had happened to Bernice, but as days became weeks and the likelihood of a happy ending diminished, the possibility of knowing became increasingly fraught with dread.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And for Mike Prozzo there was a sense that this was not an ordinary case of a missing person. Bernice Courtemanche had too many reasons to like her life, there were too many signs that she was not someone who would run away, and there was too little cause to think she was the victim of an accident. It was still not something that Prozzo wanted to put in words; in fact the idea existed almost entirely beneath the level of conscious thought, but Prozzo couldn’t shake the feeling that something was seriously wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So far, though, the circle of those who glimpsed the specter of tragedy lurking behind events was limited, confined to a few investigators and the small number of people who had known and loved Bernice Courtemanche.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That would soon change.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95d15f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter_01.vue
// module id = 84
// module chunks = 0